import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../../_interface/control-template.enum';

@Component({
	selector: 'form-button-radio',
	templateUrl: './button-radio.component.html',
	styleUrls: ['../button.component.scss']
})
export class ButtonRadioComponent implements OnInit {

	@Input()
	id: string = this.dynamicIdService.getId('button-radio');

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.horizontal;

	@Input()
	control: UntypedFormGroup;

	@Input()
	options: string[] = [];

	ControlTemplate = ControlTemplate;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
	}

}
